import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Navbar from '../Components/Navbar';
import HeroSection from '../Components/Home';
import AboutSection from '../Components/About';
import PrepSection from '../Components/ProjectPreparation'; 
import OverviewSection from '../Components/Overview'; 
import VMOSection from '../Components/VMO';
import CollabSection from '../Components/Collab';
import WorkshopSection from '../Components/Workshop';
import OfficesSection from '../Components/Offices';
import CFPSection from '../Components/CFP';
import SuccessStories from '../Components/SuccessStories';
import Chatbot from '../Components/Chatbot';
import Footer from '../Components/footer';


const HomePage = () => {
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const prepRef = useRef(null); 
  const overviewRef = useRef(null);
  const vmoRef = useRef(null); 
  const collabRef = useRef(null); 
  const workshopRef = useRef(null);
  const officeRef = useRef(null); 
  const cfpRef = useRef(null);   

  const [selectedContent, setSelectedContent] = useState(null);  

  const scrollToSection = (sectionRef) => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavClick = (item) => {

    if (selectedContent === item) {
      setSelectedContent(null);  
    } else {
      setSelectedContent(item);  
    }
  };


  useEffect(() => {
    if (selectedContent === 'PrepSection') {
      scrollToSection(prepRef); 
    } else if (selectedContent === 'OverviewSection') {
      scrollToSection(overviewRef); 
    }
    else if (selectedContent === 'VMOSection') {
      scrollToSection(vmoRef); 
    }
    else if (selectedContent === 'CollabSection') {
      scrollToSection(collabRef); 
    }
    else if (selectedContent === 'WorkshopSection') {
      scrollToSection(workshopRef); 
    }
    else if (selectedContent === 'OfficesSection') {
      scrollToSection(officeRef); 
    }
    else if (selectedContent === 'CFPSection') {
      scrollToSection(cfpRef); 
    }
  }, [selectedContent]); 

  return (
    <HomePageContainer>
      <Navbar onSelect={handleNavClick} scrollToSection={scrollToSection} refs={{ heroRef, aboutRef, prepRef, overviewRef, collabRef, workshopRef, officeRef, cfpRef }} />

    
      <Section ref={heroRef}>
        <HeroSection /> 
      </Section>

      <Section ref={aboutRef}>
        <AboutSection />
      </Section>


      {selectedContent === 'PrepSection' && (
        <Section ref={prepRef}>
          <PrepSection /> 
        </Section>
      )}

      {selectedContent === 'OverviewSection' && (
        <Section ref={overviewRef}>
          <OverviewSection /> 
        </Section>
      )}

      {selectedContent === 'VMOSection' && (
        <Section ref={vmoRef}>
          <VMOSection /> 
        </Section>
      )}

      {selectedContent === 'CollabSection' && (
        <Section ref={collabRef}>
          <CollabSection /> 
        </Section>
      )}

      {selectedContent === 'WorkshopSection' && (
        <Section ref={workshopRef}>
          <WorkshopSection /> 
        </Section>
      )}

      {selectedContent === 'OfficesSection' && (
        <Section ref={officeRef}>
          <OfficesSection /> 
        </Section>
      )}

      {selectedContent === 'CFPSection' && (
        <Section ref={cfpRef}>
          <CFPSection /> 
        </Section>
      )}

       {selectedContent === 'SuccessStories' && ( // ✅ ADD THIS
        <Section>
          <SuccessStories />
        </Section>
      )}

          <Chatbot />

      <Section>
        <Footer />
      </Section>

     
    
       
    </HomePageContainer>
  );
};

export default HomePage;

const HomePageContainer = styled.div`
  overflow-x: hidden;
  font-family: 'Poppins', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Section = styled.div`
  width: 100%;
`;

